import { createContext } from "react";

export const MicrodataContext = createContext(false);
